import React from "react";
import Label from "./Label";

/**
 * syllabus.assmt_matrix_points_arr = "20,50,100,40"
 * syllabus.assmt_type_lu_id_arr = "2,3,4,5"
 * props
 *  - Int creditHrs
 *  - Float activeLearningHrs
 *  - Float labHrs
 *  - Function handleChange Send updates to the syllabi_controller
 **/
const TeachHrs = (props) => {
  const alKey = "alhrs";
  const alHrs =
    props.focusKey === alKey ? (
      <input
        type="number"
        step="1"
        min="0"
        value={props.activeLearningHrs}
        onChange={(e) =>
          props.handleChange(
            { assoc: "syl_teach_hr", type: "al_coursework" },
            e
          )
        }
      />
    ) : (
      props.activeLearningHrs
    );

  const labKey = "labhrs";
  const labHrs =
    props.focusKey === labKey ? (
      <input
        type="number"
        step="1"
        min="0"
        value={props.labHrs}
        onChange={(e) =>
          props.handleChange({ assoc: "syl_teach_hr", type: "lab_field" }, e)
        }
      />
    ) : (
      props.labHrs
    );

  return (
    <div className="d-flex flex-row justify-content-left top-buffer">
      <Label text="Teaching Hours:" />
      <div className="d-flex" style={{ maxWidth: "30rem" }}>
        <table className="table table-bordered sm-font">
          <thead>
            <tr className="table-info">
              {/* <th className="text-align-center">Credit Hours</th> */}
              <th
                className="text-align-center"
                onClick={(e) => props.focus(alKey, e)}
              >
                Active Learning Coursework
              </th>
              <th
                className="text-align-center"
                onClick={(e) => props.focus(labKey, e)}
              >
                Inquiry Lab or Field Study
              </th>
              <th className="text-align-center">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {/* <td className="text-align-center">{props.creditHrs}</td> */}
              <td
                id={alKey}
                className="text-align-center"
                onClick={(e) => props.focus(alKey, e)}
              >
                {alHrs}
              </td>
              <td
                id={labKey}
                className="text-align-center"
                onClick={(e) => props.focus(labKey, e)}
              >
                {labHrs}
              </td>
              <td id="ttlHrs" className="text-align-center">
                {(parseFloat(props.activeLearningHrs) || 0) +
                  (parseFloat(props.labHrs) || 0)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TeachHrs;
